import { Config } from "tailwindcss";

import { SpecificationColors, SpecificationSize } from "../specification";
import AntTokens from "./ant-tokens.json";

/**
 * tailwind 配置
 *
 * ant token 使用 ant-tokens.json 静态快照，避免 CLI 启动时加载 antd（约 3~4s）。
 * PrimaryTheme 变更后需重新生成该快照。
 */
export const TailwindConfig: Config = {
  content: ["./src/**/*.{ts,less,tsx}"],
  theme: {
    extend: {
      // antd 规范 token
      ant: AntTokens,
      // 规范颜色
      colors: {
        ...SpecificationColors,
      },
      // 规范尺寸
      size: {
        ...SpecificationSize,
      },
    },
  },
  plugins: [],
};
